import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LogEntry } from '../shared/services/log/log.action';
import { Store } from '@ngxs/store';
import { LogEntryModel } from '../models/logentry';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector,
    //         private store: Store,
    //         private logService: LogService
  ) { }

  handleError(error) {
    /*
    // https://medium.com/@amcdnl/global-error-handling-with-angular2-6b992bdfb59c

    const loggingService = this.injector.get(LoggingService);
    const message = error.message ? error.message : error.toString();
    // log on the server
    loggingService.log({ message });
    */
    const loggingDispatche = this.injector.get(Store);
    const errorEntry = new LogEntryModel();
    errorEntry.entry = error.toString();
    errorEntry.methodName = 'GlobalHandleError';
    errorEntry.type = 'error';
    // loggingDispatche.SaveLogError(logEntry);
    loggingDispatche.dispatch(new LogEntry(errorEntry));

    // IMPORTANT: Rethrow the error otherwise it gets swallowed
    throw error;
  }

}
